import { isTablet } from 'helpers/device_helper';

export default {
    fontFamily: "'Nunito', 'Rubik'",
    h1: {
        fontFamily: "'Nunito', 'Rubik'",
        fontWeight: 700,
        fontSize: '3rem',
        lineHeight: 1,
        letterSpacing: 'normal',
        ...isTablet({
            fontSize: '3.6rem',
        }),
    },
    h2: {
        fontFamily: "'Nunito', 'Rubik'",
        fontWeight: 300,
        fontSize: '2.5rem',
        lineHeight: 1,
        letterSpacing: '-0.00833em',
    },
    h3: {
        fontFamily: "'Nunito', 'Rubik'",
        fontWeight: 400,
        fontSize: '2.2rem',
        lineHeight: 1.04,
        letterSpacing: '0em',
    },
    h4: {
        fontFamily: "'Nunito', 'Rubik'",
        fontWeight: 600,
        fontSize: '2rem',
        lineHeight: 1.17,
        letterSpacing: '0.00735em',
    },
    h5: {
        fontFamily: "'Nunito', 'Rubik'",
        fontWeight: 600,
        fontSize: '1.6rem',
        lineHeight: 1,
        letterSpacing: 'normal',
    },
    h6: {
        fontFamily: "'Nunito', 'Rubik'",
        fontWeight: 500,
        fontSize: '1.25rem',
        lineHeight: 1.6,
        letterSpacing: '0.0075em',
    },
    subtitle1: {
        fontFamily: "'Nunito', 'Rubik'",
        fontWeight: 400,
        fontSize: '1.6rem',
        lineHeight: 1.75,
        letterSpacing: '0.00938em',
    },
    subtitle2: {
        fontFamily: "'Nunito', 'Rubik'",
        fontWeight: 500,
        fontSize: '1.2rem',
        lineHeight: 1.57,
        letterSpacing: '0.00714em',
    },
    body1: {
        fontFamily: "'Nunito', 'Rubik'",
        fontWeight: 600,
        fontSize: '1.6rem',
        letterSpacing: 'initial',
        lineHeight: 'initial',
    },
    body2: {
        fontFamily: "'Nunito', 'Rubik'",
        fontWeight: 600,
        fontSize: '1.2rem',
        letterSpacing: 'initial',
        lineHeight: 'initial',
    },
    button: {
        fontFamily: "'Nunito', 'Rubik'",
        fontWeight: 500,
        fontSize: '0.875rem',
        lineHeight: 1.75,
        letterSpacing: '0.02857em',
    },
    caption: {
        fontFamily: "'Nunito', 'Rubik'",
        fontWeight: 400,
        fontSize: '1rem',
        lineHeight: 1.66,
        letterSpacing: '0.03333em',
    },
    overline: {
        fontFamily: "'Nunito', 'Rubik'",
        fontWeight: 400,
        fontSize: '0.75rem',
        lineHeight: 2.66,
        letterSpacing: '0.08333em',
    },
};
